import {gql} from '@apollo/client';

export const userMutations = {
    UPDATE_USER: gql`
        mutation UpdateUser($input: AddUserViewModelInput!) {
            updateUser(input: $input) {
                id
                firstName
                lastName
                fullName
                userName
                email
                phoneNumber
                active
            }
        }
    `,
};
